'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeOrganisationIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeOrganisationIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 90 90"
        id="Building-Office--Streamline-Core"
        height="90"
        width="90"
      >
        <desc>Building Office Streamline Icon: https://streamlinehq.com</desc>
        <g id="building-office--travel-places-building-office">
          <path
            id="Union"
            fill="#d8dce5"
            fillRule="evenodd"
            d="M12.857142857142858 3.2142857142857144C7.531521428571429 3.2142857142857144 3.2142857142857144 7.531521428571429 3.2142857142857144 12.857142857142858v70.71428571428572c0 1.7749285714285716 1.439087142857143 3.2142857142857144 3.2142857142857144 3.2142857142857144h51.42857142857143V12.857142857142858C57.85714285714286 7.531521428571429 53.53990714285715 3.2142857142857144 48.214285714285715 3.2142857142857144H12.857142857142858Z"
            clipRule="evenodd"
            strokeWidth="6.4286"
          ></path>
          <path
            id="Union_2"
            fill="#5073c3"
            fillRule="evenodd"
            d="M61.07142857142858 32.142857142857146H57.85714285714286v54.642857142857146h25.714285714285715c1.7749285714285716 0 3.2142857142857144 -1.4393571428571428 3.2142857142857144 -3.2142857142857144V41.785714285714285c0 -5.325621428571429 -4.317428571428572 -9.642857142857142 -9.642857142857142 -9.642857142857142H61.07142857142858Z"
            clipRule="evenodd"
            strokeWidth="6.4286"
          ></path>
          <path
            id="Union_3"
            fill="#5073c3"
            fillRule="evenodd"
            d="M46.60714285714286 22.5c0 -2.662778571428572 -2.1586499999999997 -4.821428571428571 -4.821428571428571 -4.821428571428571s-4.821428571428571 2.1586499999999997 -4.821428571428571 4.821428571428571v6.428571428571429c0 2.662778571428572 2.1586499999999997 4.821428571428571 4.821428571428571 4.821428571428571s4.821428571428571 -2.1586499999999997 4.821428571428571 -4.821428571428571v-6.428571428571429ZM19.285714285714285 40.17857142857143c2.662778571428572 0 4.821428571428571 2.1586499999999997 4.821428571428571 4.821428571428571v6.428571428571429c0 2.662778571428572 -2.1586499999999997 4.821428571428571 -4.821428571428571 4.821428571428571s-4.821428571428571 -2.1586499999999997 -4.821428571428571 -4.821428571428571V45c0 -2.662778571428572 2.1586499999999997 -4.821428571428571 4.821428571428571 -4.821428571428571Zm22.5 0c2.662778571428572 0 4.821428571428571 2.1586499999999997 4.821428571428571 4.821428571428571v6.428571428571429c0 2.662778571428572 -2.1586499999999997 4.821428571428571 -4.821428571428571 4.821428571428571s-4.821428571428571 -2.1586499999999997 -4.821428571428571 -4.821428571428571V45c0 -2.662778571428572 2.1586499999999997 -4.821428571428571 4.821428571428571 -4.821428571428571ZM19.285714285714285 17.67857142857143c2.662778571428572 0 4.821428571428571 2.1586499999999997 4.821428571428571 4.821428571428571v6.428571428571429c0 2.662778571428572 -2.1586499999999997 4.821428571428571 -4.821428571428571 4.821428571428571s-4.821428571428571 -2.1586499999999997 -4.821428571428571 -4.821428571428571v-6.428571428571429c0 -2.662778571428572 2.1586499999999997 -4.821428571428571 4.821428571428571 -4.821428571428571Zm16.071428571428573 54.642857142857146v14.464285714285715H25.714285714285715v-14.464285714285715c0 -2.662714285714286 2.1586499999999997 -4.821428571428571 4.821428571428571 -4.821428571428571s4.821428571428571 2.158714285714286 4.821428571428571 4.821428571428571Z"
            clipRule="evenodd"
            strokeWidth="6.4286"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

LargeOrganisationIcon.propTypes = {
  sx: PropTypes.object
}
